<template>
    <section class="paint-how-wrapper">
        <span class="paint-how-top-span">Jak pracujemy?</span>
        <div class="paint-how-top">
            <article class="paint-top-text">
                <span class="paint-how-span2">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Autem suscipit, ipsa dolores ea molestias accusamus animi itaque laudantium praesentium? Quis, architecto laborum amet odit illum sit fugit magni consequuntur quae dolor, adipisci cumque?</span>
                <span class="paint-how-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, adipisci nam architecto, rerum ex aperiam distinctio mollitia dolorem sit quasi voluptatum eius.</span>
            </article>
            <div class="paint-top-img"></div>
        </div>
        <div class="paint-how-bottom">
            <article class="paint-bottom">
                <span class="paint-how-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod ut eveniet quam in fugiat excepturi accusamus voluptatem rem neque placeat!</span>
                <span class="paint-how-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam, dignissimos. Quae obcaecati, necessitatibus asperiores possimus quas dolorum dicta illum!</span>
            </article>
            <article class="paint-bottom">
                <span class="paint-how-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod ut eveniet quam in fugiat
                    excepturi accusamus voluptatem rem neque placeat!</span>
                <span class="paint-how-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam, dignissimos.</span>
            </article>
        </div>
    </section>
</template>

<script>
export default {
    name: 'paint-how',
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
.paint-how-wrapper {
    width: 100%;
    height: 700px;
    display: flex;
    flex-direction: column;
    @include mobileBig {
        height: auto;
    }
    .paint-how-top-span {
        font-size: 40px;
        margin: 50px 0 20px 0;
    }
    .paint-how-top {
        height: 60%;
        display: flex;
        flex-direction: row;
        width: 100%;
        margin: 50px 0;
        padding: 0 100px 0 100px;
        @include mobileBig {
            flex-direction: column;
            margin: 0 0 20px 0;
            padding: 0 50px;
        }
        .paint-top-text {
            height: 100%;
            width: 60%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            @include mobileBig {
                width: 100%;
                height: auto;
            }
            .paint-how-span2 {
                font-size: 24px;
                margin: 0 50px 20px 0;
                text-align: left;
                @include mobileBig {
                    font-size: 20px;
                    margin: 0 0 30px 0;
                    text-align: center;
                }
            }
        }
        .paint-top-img {
            height: 100%;
            width: 40%;
            background-size: cover;
            background-position: center;
            background-image: url('../../../public/img/img_home.jpg');
            @include mobileBig {
                width: 100%;
                height: 200px;
            }
        }
    }
    .paint-how-bottom {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 40%;
        margin: 0 0 50px 0;
        padding: 0 100px;
        @include mobileBig {
            padding: 0 50px;
            height: auto;
            flex-direction: column;
        }
        .paint-bottom {
            justify-content: center;
            align-items: center;
            width: 50%;
            height: 100%;
            display: flex;
            flex-direction: column;
            @include mobileBig {
                width: 100%;
            }
            .paint-how-span2 {
                font-size: 20px;
                margin: 10px 20px 10px 20px;
            }
        }
    }
}
</style>